import React, { useState } from 'react'
import './CareersPage.scss'
import emailjs from '@emailjs/browser';
import Loader from '../Loader/Loader';
import BrouchureImage1 from '../Assets/Brochures/1.jpg'
import BrouchureImage2 from '../Assets/Brochures/2.jpg'
import BrouchureImage3 from '../Assets/Brochures/3.jpg'
import BrouchureImage4 from '../Assets/Brochures/4.jpg'
import BrouchureImage5 from '../Assets/Brochures/5.jpg'
import BrouchureImage6 from '../Assets/Brochures/6.jpg'

const CareersPage = () => {
  const [FormParams, setFormParams] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  })
  const [Loading, setLoading] = useState(false);

  const handleInputchange = (e) => {
    const id = e.target.id
    const value = e.target.value
    setFormParams((prev) => ({
      ...prev,
      [id] : value
    }))
  }

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs.send('service_zel4ero', 'template_x1cuipq', FormParams, 'fSI6eq23OQNOviA5E')
      .then(
        () => {
          setLoading(false);
          alert('Hurray!! Your message has sent successfully!');
          setFormParams({
            name: '',
            email: '',
            subject: '',
            message: ''
          });
        },
        (error) => {
          setLoading(false);
          console.log('FAILED...', error.text);
          alert('Oops! something went wrong. Please try again later.');
        },
      );
  };

  return (
    <main className='CareersPage'>
      <h1>Join our team</h1>
      <p>Are you in your final or pre-final year of study? Are you passionate about biological sciences and eager to gain hands-on experience in various disciplines? If so, we have exciting opportunities for you!</p>
      <h3>Brochure</h3>
      <section className='Brochure'>
        {/* <div>
          <img src={Image}/>
        </div>
        <div className='UList'>
          <h3>Internship Programs Available:</h3>
          <p>We are inviting applications for 3 and 6-month internship programs in the following biological disciplines:</p>
          <ul>
            <li>Cell & Molecular Biology</li>
            <li>Analytical Biochemistry</li>
            <li>Clinical Biochemistry</li>
            <li>Histology Analysis</li>
            <li>In vitro Cell Line Studies</li>
          </ul>
        </div> */}
        <a href={BrouchureImage1} target="_blank">
          <img src={BrouchureImage1} alt=''/>
        </a>
        <a href={BrouchureImage2} target="_blank">
          <img src={BrouchureImage2} alt=''/>
        </a>
        <a href={BrouchureImage3} target="_blank">
          <img src={BrouchureImage3} alt=''/>
        </a>
        <a href={BrouchureImage4} target="_blank">
          <img src={BrouchureImage4} alt=''/>
        </a>
        <a href={BrouchureImage5} target="_blank">
          <img src={BrouchureImage5} alt=''/>
        </a>
        <a href={BrouchureImage6} target="_blank">
          <img src={BrouchureImage6} alt=''/>
        </a>
      </section>
      <h3>Join Our Team</h3>
      <p>We are always on the lookout for enthusiastic and energetic candidates who are ready to roll up their sleeves and dive into real-world research. If you're ready to work with us and contribute to groundbreaking projects, we want to hear from you!</p>
      <h3>How to Apply</h3>
      <p>Please submit your resume to <a href='mailto:adrc1820@gmail.com'>adrc1820@gmail.com</a> to be considered for these internship opportunities.<br/>Don't miss out on this chance to gain valuable experience and jumpstart your career in biological sciences. Apply now!</p>
      <h3>Have any queries?</h3>
      <p>If you have a question or require assistance, kindly submit your inquiry using the form below. A dedicated member of our team will strive to respond promptly and efficiently to address your needs.</p>
      <form onSubmit={sendEmail}>
        <label>Name</label>
        <input type='text' value={FormParams.name} placeholder='Enter Full Name' required id='name' onChange={handleInputchange}/>
        <label>Email Id</label>
        <input type='email' value={FormParams.email} placeholder='Enter Valid Email Id' required id='email' onChange={handleInputchange}/>
        <label>Subject</label>
        <input type='text' value={FormParams.subject} placeholder='Enter Subject' required id='subject' onChange={handleInputchange}/>
        <label>Message</label>
        <textarea type='text' value={FormParams.message} placeholder='Enter your message or enquiry' required id='message' onChange={handleInputchange}/>
        <button disabled={Loading} type='submit'>{Loading ? <Loader size={'2rem'}/> : 'Submit'}</button>
      </form>
    </main>
  )
}

export default CareersPage